export const supplierAr = {
  "Nom": "الاسم",
  "Telephone": "الهاتف",
  "Balance": "الرصيد",
  "Actions": "إجراءات",
  "Chercher un Founisseur": "ابحث عن مورد",

  "Montant": "المبلغ",
  "Note": "ملحوظة",
  "Date": "التاريخ",
  "Aujourd'hui": "اليوم",

  "Choisir un fournisseur": "اختر موردًا",
  "Information du fournisseur": "معلومات المورد",

}